<!--
 * @FilePath: /src/App.vue
 * @Description: 根目录
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue